"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.firstCharToUpperCase = exports.toLowerAndStrip = void 0;

var toLowerAndStrip = function toLowerAndStrip(text) {
  return text && text.toLowerCase().replace(/\s/g, '');
};

exports.toLowerAndStrip = toLowerAndStrip;

var firstCharToUpperCase = function firstCharToUpperCase(text) {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

exports.firstCharToUpperCase = firstCharToUpperCase;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9UZXh0LnRzIl0sIm5hbWVzIjpbInRvTG93ZXJBbmRTdHJpcCIsInRleHQiLCJ0b0xvd2VyQ2FzZSIsInJlcGxhY2UiLCJmaXJzdENoYXJUb1VwcGVyQ2FzZSIsImNoYXJBdCIsInRvVXBwZXJDYXNlIiwic2xpY2UiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSxlQUFlLEdBQUcsU0FBbEJBLGVBQWtCLENBQUNDLElBQUQ7QUFBQSxTQUFrQkEsSUFBSSxJQUFJQSxJQUFJLENBQUNDLFdBQUwsR0FBbUJDLE9BQW5CLENBQTJCLEtBQTNCLEVBQWtDLEVBQWxDLENBQTFCO0FBQUEsQ0FBeEI7Ozs7QUFDQSxJQUFNQyxvQkFBb0IsR0FBRyxTQUF2QkEsb0JBQXVCLENBQUNILElBQUQ7QUFBQSxTQUFrQkEsSUFBSSxDQUFDSSxNQUFMLENBQVksQ0FBWixFQUFlQyxXQUFmLEtBQStCTCxJQUFJLENBQUNNLEtBQUwsQ0FBVyxDQUFYLENBQWpEO0FBQUEsQ0FBN0IiLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCB0b0xvd2VyQW5kU3RyaXAgPSAodGV4dDogc3RyaW5nKSA9PiB0ZXh0ICYmIHRleHQudG9Mb3dlckNhc2UoKS5yZXBsYWNlKC9cXHMvZywgJycpO1xuY29uc3QgZmlyc3RDaGFyVG9VcHBlckNhc2UgPSAodGV4dDogc3RyaW5nKSA9PiB0ZXh0LmNoYXJBdCgwKS50b1VwcGVyQ2FzZSgpICsgdGV4dC5zbGljZSgxKTtcblxuZXhwb3J0IHtcbiAgdG9Mb3dlckFuZFN0cmlwLFxuICBmaXJzdENoYXJUb1VwcGVyQ2FzZSxcbn07XG4iXX0=